import {
  OrderEditActionType,
  SetOrderEditLoadingAction,
  SetIsStoringAction
} from 'src/contract/_components/order-edit/order-edit.actions';
import { createReducer } from '@common/redux-utils';

export interface OrderEditState {
  readonly isLoadingContract: boolean;
  readonly isStoringPropertyInfo: boolean;
  readonly isStoringAffiliatesInfo: boolean;
  readonly isStoringPriceAdjustmentInfo: boolean;
  readonly isStoringCoverageInfo: boolean;
}

export const initOrderEditState: OrderEditState = {
  isLoadingContract: false,
  isStoringPropertyInfo: false,
  isStoringAffiliatesInfo: false,
  isStoringPriceAdjustmentInfo: false,
  isStoringCoverageInfo: false
};

export function handleSetOrderEditLoading(state: OrderEditState, action: SetOrderEditLoadingAction): OrderEditState {
  return {
    ...state,
    isLoadingContract: action.isLoading
  };
}

export function handleSetIsStoringPropertyInfo(state: OrderEditState, action: SetIsStoringAction): OrderEditState {
  return {
    ...state,
    isStoringPropertyInfo: action.isStoring
  };
}

export function handleSetIsStoringAffiliatesInfo(state: OrderEditState, action: SetIsStoringAction): OrderEditState {
  return {
    ...state,
    isStoringPropertyInfo: action.isStoring
  };
}

export function handleSetIsStoringCoverageInfo(state: OrderEditState, action: SetIsStoringAction): OrderEditState {
  return {
    ...state,
    isStoringPropertyInfo: action.isStoring
  };
}

export function handleSetIsStoringPriceAdjustmentInfo(
  state: OrderEditState,
  action: SetIsStoringAction
): OrderEditState {
  return {
    ...state,
    isStoringPropertyInfo: action.isStoring
  };
}
export const OrderEditReducer = createReducer<OrderEditState, OrderEditActionType>(initOrderEditState, {
  [OrderEditActionType.SetOrderEditLoading]: handleSetOrderEditLoading,
  [OrderEditActionType.SetIsStoringPropertyInfo]: handleSetIsStoringPropertyInfo,
  [OrderEditActionType.SetIsStoringAffiliatesInfo]: handleSetIsStoringAffiliatesInfo,
  [OrderEditActionType.SetIsStoringPriceAdjustmentInfo]: handleSetIsStoringPriceAdjustmentInfo,
  [OrderEditActionType.SetIsStoringCoverageInfo]: handleSetIsStoringCoverageInfo
});



// WEBPACK FOOTER //
// ./src/contract/_components/order-edit/order-edit.reducer.tsx